import { DatabaseEntities } from "../../../common/models/database-entities.model";

export class NurseWheels extends DatabaseEntities<NurseWheels> {
    value: string;
}
